import FleurKintsugi from "../brand/FleurKintsugi";
import KintsugiScrollVein from "../brand/KintsugiScrollVein";
import Reveal from "./Reveal";

const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
const VEINS = ["diagonal", "corner-br", "horizontal", "corner-tl", "s-curve"];

function Block({ text, idx }) {
  if (text.startsWith("«")) {
    return (
      <blockquote className="story-quote magma-halo my-10" data-testid={`story-quote-${idx}`}>
        <FleurKintsugi size={22} variant="line" glow={false} className="shrink-0 mt-2 opacity-80" />
        <p className="font-vibes molten-flow leading-[1.2]" style={{ fontSize: "clamp(1.7rem, 2.8vw, 2.4rem)" }}>{text}</p>
      </blockquote>
    );
  }
  const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
  if (lines.length > 1) {
    return (
      <ul className="story-litany my-8">
        {lines.map((l, i) => (
          <li key={i}><span className="story-litany-dot" aria-hidden="true" />{l}</li>
        ))}
      </ul>
    );
  }
  return <p className={idx === 0 ? "story-drop-cap" : ""}>{text}</p>;
}

export default function StoryChapter({ index, title, body, image, imageAlt = "", children }) {
  const blocks = body.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  const flip = index % 2 === 1;
  return (
    <section className="relative overflow-hidden py-16 lg:py-24" data-testid={`story-chapter-${index}`}>
      <KintsugiScrollVein variant={VEINS[index % VEINS.length]} strokes={2} opacity={0.32} />
      <div className={`relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid gap-8 lg:gap-14 ${image ? "lg:grid-cols-[120px_1fr_0.8fr]" : "lg:grid-cols-[120px_1fr]"}`}>
        <Reveal className="relative">
          <div className="story-numeral" aria-hidden="true">{ROMAN[index] || index + 1}</div>
        </Reveal>

        <Reveal delay={120} className="story-prose max-w-2xl">
          <div className="smallcaps-label mb-4" style={{ fontSize: "0.65rem" }}>Chapitre {ROMAN[index] || index + 1}</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-[2.6rem] leading-tight mb-8" data-testid={`story-chapter-title-${index}`}>
            {title}
          </h2>
          {blocks.map((b, i) => <Block key={i} text={b} idx={i} />)}
        </Reveal>

        {image && (
          <Reveal delay={260} className="self-center">
            <div className="kintsugi-frame aspect-[4/5] w-full max-w-sm mx-auto" style={{ transform: flip ? "rotate(-2deg)" : "rotate(2deg)" }}>
              <img src={image} alt={imageAlt} loading="lazy" />
            </div>
          </Reveal>
        )}
      </div>
      {children && (
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-[120px_1fr] gap-8 lg:gap-14">
          <div className="hidden lg:block" />
          <div>{children}</div>
        </div>
      )}
    </section>
  );
}
